export default class NotaFiscalServicoEletronicaItemModel {
    descricao = "";
    quantidade = 1;
    valorUnitario = 0;
    valorTotal = 0;
}
